import { FaGlasses } from "react-icons/fa";
import { HiExclamation } from "react-icons/hi";
import  * as def from "../../StrategyMapView.def";
export function StrategyMapViewSimFlag({state, onViewChanges, onBackToLive}: {state: def.StrategyMapViewStateProps, onViewChanges: () => void, onBackToLive: () => void}) {
  return (
    <>
      {state.get.strageyMapData?.is_sim_pending &&
        !state.get.loadingSingleStrategyMap && (
          <div className="relative group">
            <div
              className={`flex items-center gap-1 px-1.5 py-1 rounded-md mr-1 cursor-help transition-transform duration-200 hover:scale-110 shadow-sm  ${
                state.get.simulation
                  ? "bg-emerald-100 text-emerald-600 dark:bg-emerald-900/40 dark:text-emerald-400"
                  : "bg-orange-100 text-orange-600 dark:bg-orange-900/40 dark:text-orange-400"
              }`}
            >
              <HiExclamation className="w-4 h-4" />
              <FaGlasses className="w-3 h-3" />
            </div>
            <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity duration-300 z-50">
              <div className="px-4 py-3 text-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg shadow-xl min-w-[280px]">
                <div className="flex items-center gap-2 mb-2">
                  <HiExclamation
                    className={`w-4 h-4 flex-shrink-0 ${
                      state.get.simulation
                        ? "text-emerald-500 dark:text-emerald-400"
                        : "text-orange-500 dark:text-orange-400"
                    }`}
                  />
                  <span className="font-semibold text-gray-900 dark:text-white">
                    {state.get.simulation
                      ? "Simulation Active"
                      : "Changes Available"}
                  </span>
                </div>
                <div className="text-gray-600 dark:text-gray-300 mb-3 leading-relaxed">
                  {state.get.simulation
                    ? "You are viewing simulation mode. Merge changes to apply them to live mode."
                    : "There are changes in simulation mode. Switch to simulation to view changes."}
                </div>
                <div className="flex gap-2">
                  {!state.get.simulation ? (
                    <>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          if (onViewChanges) onViewChanges();
                        }}
                        className="px-3 py-1.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded text-xs font-medium transition-colors duration-200 flex-1"
                      >
                        View Changes
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          if (onBackToLive) onBackToLive();
                        }}
                        className="px-3 py-1.5 bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 text-white rounded text-xs font-medium transition-colors duration-200 flex-1"
                      >
                        Back to Live
                      </button>
                    </>
                  )}
                </div>
              </div>
              <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-white dark:bg-gray-800 border-l border-t border-gray-200 dark:border-gray-600 rotate-45"></div>
            </div>
          </div>
        )}
    </>
  );
}